import { gql } from '@apollo/client';

export const NEWSLETTER_FRAGMENT = gql`
  fragment Newsletter on Newsletter {
    _id
    aiDefaultPromptHeader
    aiDefaultPromptObject
    automationConfig
    automationQuery
    automationTime
    available
    brandKey
    campaignPreHeaderPattern
    campaignSubjectPattern
    createdAt
    defaultCampaignSectionCount
    autoValidateXMLCampaign
    frequency
    id
    linkUrl
    isFromNlf
    nlfName
    previewUrl
    sections
    medias {
      caption
      focusPoint
      format
      href
      iframely
      src
      title
      url
    }
    name
    rawMedias
    sentAt
    updatedAt
  }
`;
